import { portalAction, PortalThunk } from '../'
import { CountryConfig } from '../../model'

export const loadCountryConfig: PortalThunk<void, { countries: CountryConfig[] }> = portalAction('countries', async (request, thunk) => {
  return await thunk.extra.portalApi().get('/countries')
})
